<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title> Adjust Stock </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" md="4">
           <span style="font-size: 18px; font-weight: bold; color: blue;">{{ storeName }}</span>
          </v-col>

          <v-col cols="12" md="8">
            <v-autocomplete autocomplete="off" v-model="select" :isloading="isLoading"
              :items="products" :search-input.sync="searchProducts" @change="queryStockBalance(select)"
              :item-text="smsRef == 'pharmacy' ? 'full_name' : 'Name'" item-value="id" cache-items flat hide-no-data
              hide-details label="Search Product" outlined dense>
            </v-autocomplete> </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row dense class="mt-2">
          <v-col cols="12" xs="12" md="12">
            <v-row>

              <v-col cols="12" md="1">
                <!-- excel icon -->
                <download-excel :data="inventory" :fields="fields" name="Stock List">
                  <v-icon color="green">mdi-file-excel</v-icon>
                </download-excel>
                <!-- end -->
              </v-col>

              <v-col cols="4">
                <v-btn v-if="inventory.length > 0" color="accent" @click="printStockViaThermal" text>
                  <v-icon left>mdi-printer</v-icon>Print Stock Via Thermal
                </v-btn>
              </v-col>

              <v-col cols="12" style="margin-top: -20px">
                <!-- start of table -->
                <v-data-table :loading="loader" loading-text="Loading Data......" :headers="headers" :items="inventory"
                  :items-per-page="2000">
                  <!-- <template v-slot:item.Name="{ item }">
                    <v-btn color="primary" text :to="`/quick-audit/${item.productId}`">{{
                      item.Name }}</v-btn>
                  </template> -->

                  <template v-slot:item.AvailableQty="{ item }">
                    <span>{{ item.purchaseUomQty }}</span>
                  </template>

                  <template v-slot:item.PurchaseUnit="{ item }">
                    <span v-if="item.HasUom == 1 && item.BaseStockActive == 'N'">{{ item.PurchaseUnit }}</span>
                  </template>

                  <template v-slot:item.BaseUnitStock="{ item }">
                    <span v-if="item.HasUom == 1 && item.BaseStockActive == 'N'">{{ item.BaseUnitStock }}</span>
                  </template>

                  <template v-slot:item.BaseUnit="{ item }">
                    <span v-if="item.HasUom == 1 && item.BaseStockActive == 'N'">{{ item.BaseUnit }}</span>
                  </template>

                  <!-- action template -->
                  <template v-slot:item.action="{ item }">
                    <v-btn color="editIcon" @click="openModal(item)" text>
                      <v-icon left>mdi-pencil</v-icon>Adjust Stock
                    </v-btn>
                  </template>
                  <!-- end -->

                </v-data-table>
                <!-- end -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- snackbar -->

        <!-- Inventory Edit dialog -->
        <v-dialog v-model="dialog" max-width="800px">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title>Adjust Stock Here</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="displayText dense">
                  <v-col cols="12" xs="12" md="8">
                    <span
                      class="style-16"
                      style="color: red; font-size: 18px"
                    >{{ editItem && editItem.Name }}</span>
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <span class="style-16">Available: {{ editItem && editItem.AvailableQty }}</span>
                  </v-col>
                </v-row>

                <!-- non uom product -->
                <v-row v-if="editItem && editItem.HasUom == 0">
                  <v-col cols="12" xs="12" md="6">
                    <v-text-field
                      type="number"
                      autocomplete="off"
                      v-model="editItem.CorrectQuantity"
                      label="Correct Quantity"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="subtitle-2 text--primary" v-if="editItem && editItem.HasUom == 1">
                  <v-col cols="4">Unit</v-col>

                  <v-col cols="4">Available Qty</v-col>

                  <v-col cols="4">Total (Base Unit)</v-col>
                </v-row>

                <!-- uom product -->
                <v-row
                  dense
                  v-if="editItem && editItem.HasUom == 1"
                  class="subtitle-2 text--primary docForm"
                >
                  <v-col cols="12" v-for="(record, index) in editItem.Ugp1Records" :key="index">
                    <v-row>
                      <v-col cols="4">{{ record.uom.UomName }}</v-col>

                      <v-col cols="4">
                        <v-text-field
                          style="width: 200px"
                          autocomplete="off"
                          type="number"
                          class="orderInput"
                          single-line
                          outlined
                          dense
                          v-model="record.quantity"
                        ></v-text-field>
                      </v-col>

                      <v-col
                        cols="4"
                      >{{ record.quantity ? record.quantity * record.BaseQty : '' }} {{record.quantity ? editItem && editItem.BaseUnit : '' }}</v-col>
                    </v-row>

                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <!-- end of uom product -->

                <v-row>
                  <v-col cols="12" xs="12" md="12">
                    <v-textarea
                      v-model="editItem.Narration"
                      label="Remarks"
                      outlined
                      dense
                      rows="2"
                    ></v-textarea>
                  </v-col>

                  <v-col cols="12">
                    <v-btn
                      color="primary"
                      @click="adjustStock"
                      :loading="loader"
                      :disabled="loader"
                    >
                      <v-icon left>mdi-content-save</v-icon>Adjust
                    </v-btn>
                  </v-col>
                </v-row>
                <!-- end of non uom product -->
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of edit dialog -->



      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>


<script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
  },
  data() {
    return {
      selectedStoreName: "",
      showPrinterDiv: false,
      DefaultDistributorCustomer: 0,
      smsRef: "",
      select: "",
      isLoading: false,
      search: null,
      searchStock: null,
      pageItems: 500,
      loader: false,
      editItem: {},
      damagedItem: {},
      transferItem: {},
      store: null,
      queryStore: null,
      stores: [],
      users: [],
      date: null,
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      searchProducts: null,
      todayDate: new Date().toISOString().substr(0, 10),
      products: [],
      headers: [
        { text: "Item Code", value: "ItemCode" },
        { text: "Product Name", value: "Name" },
        { text: "Available Qty", value: "AvailableQty" },
        // { text: "Purchase Unit", value: "purchaseUomQty" },
        { text: "Purchase Uom", value: "PurchaseUnit" },
        { text: "Base Unit Stock", value: "BaseUnitStock" },
        { text: "Base Unit", value: "BaseUnit" },
        { text: "Action", value: "action" },
      ],
      fields: {
        ItemCode: "ItemCode",
        Product: "Name",
        AvailableQty: "AvailableQty",
      },
      inventory: [],
    };
  },
  watch: {
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
  },
  methods: {
    openModal(item) {
      this.editItem = Object.assign({}, item);
      this.dialog = true;
    },
    queryData() {
      const id = this.queryStore;

      var selectedStore = this.stores.find((record) => {
        return record.id === id;
      });

      const pos = this.stores.indexOf(selectedStore);
      if (pos === -1) {
        return;
      }

      this.selectedStoreName = selectedStore.Name;

      const self = this;
      self.loader = true;
      this.$store
        .dispatch("get", `/check-stock/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            if (res.ResponseData != null) {
              self.inventory = res.ResponseData;
            }

            if (res.ResponseData == null) {
              self.inventory = [];
            }

          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    queryStockBalance(val) {
      const self = this;
      var storeId = parseInt(this.activeStore);
      var productId = parseInt(val);

      const url = `/get-stock-balance/${storeId}/${productId}`;

      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null) {
              self.inventory = res.ResponseData;
              self.select = "";
            }

            if (res.ResponseData == null) {
              self.inventory = [];
            }

          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search/by/name";

      var customerId = 0;

      const data = {
        SearchText: searchText,
        CustomerId: customerId
      };
      
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null) {
              self.products = res.ResponseData;
            }

            if (res.ResponseData == null) {
              self.products = [];
            }

          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    printStockViaThermal() {
      // Get the HTML content you want to print
      const content = document.getElementById("print-stock").innerHTML;

      // Open a new print window
      const printWindow = window.open(
        "",
        "",
        "left=0,top=0,width=100,height=auto,toolbar=0,scrollbars=0,status=0"
      );

      // Write the HTML to the print window, including the content
      printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body {
            width: 80mm;
            margin: 0 auto;
          }
          @page {
            size: auto;  /* auto is the current printer page size */
            margin: 0mm; /* this affects the margin in the printer settings */
          }
        </style>
      </head>
      <body onload="window.print(); window.close();">${content}</body>
    </html>
  `);

      printWindow.document.close();
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    glAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/gl-integration`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.DefaultDistributorCustomer = res.ResponseData.DefaultDistributorCustomer;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
       adjustStock() {
      var HasUom = this.editItem.HasUom;

      var quantity = 0;

      if (HasUom == 0) {
        quantity = parseFloat(this.editItem.CorrectQuantity);
      }

      let uomArray = [];
      if (HasUom == 1) {
        for (const item of this.editItem.Ugp1Records) {
          if (item.quantity) {
            var qty = parseFloat(item.quantity);
            uomArray.push({
              UgpEntry: item.UgpEntry,
              UomEntry: item.UomEntry,
              Quantity: qty
            });
          }
        }
      }

      var data = {
        StoreId: parseInt(this.activeStore),
        HasUom: HasUom,
        productId: this.editItem.productId,
        correctQuantity: quantity,
        uomData: uomArray
      };

      const url = `/adjust-stock`;
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.dialog = false;
            self.queryData();
            self.queryStockBalance(self.editItem.productId);
            this.$refs.snackbar.show("Adjustment successful", "green");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          self.loader = false;
        });
    },
  },
  created() {
    Promise.all([this.getStores(), this.glAccounts()]);
  },
};
</script>

<style lang="scss" scoped></style>